export { default } from "./UserDetails"
export { default as ChangePasswordForm } from "./ChangePasswordForm"


// WEBPACK FOOTER //
// ./src/components/UserDetails/index.ts